import React, {useState} from 'react';
import './MenuNavProfile.css';

const MenuNavProfile = ({handleSelectedTab}) => {
  const [buttonList, setButtonList] = useState([
    {id: 'profile', value: 'Профиль', active: true},
    {id: 'tasks', value: 'Задачи', active: false},
    {id: 'calendar', value: 'Календарь', active: false},
    {id: 'myOrganizations', value: 'Мои организации', active: false},
    {id: 'work', value: 'Работа', active: false},
    {id: 'subscriptions', value: 'Подписки', active: false},


  ]);

  const handleClickButton = (e) => {
    const clickedId = e.currentTarget.dataset.id;
    setButtonList((prev) =>
      prev.map((item) => ({
        ...item,
        active: item.id === clickedId,
      }))
    );
    handleSelectedTab(clickedId);
  };

  return (
    <div className='menu-nav-profile'>
      <div className='menu-nav-profile__wrapper'>
        <div className='menu-nav-profile__buttons-list'>
          {buttonList.map((item) => (
            <div
              data-id={item.id}
              onClick={handleClickButton}
              key={item.id}
              className={`menu-nav-profile__item ${
                item.active ? 'menu-nav-profile__item_active' : ''
              }`}
            >
              <span
                className={`menu-nav-profile__item-link ${
                  item.active ? 'menu-nav-profile__item-link_active' : ''
                }`}
              >
                <span className='menu-nav-profile__item-text'>
                  {item.value}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuNavProfile;
